import en from "commonAssets/i18n/en";

en["deadlines_passed_note"] = "The deadlines in this settlement have passed.";
en["in_store_benefit_dates"] = "In-Store Benefit Dates";
en["in_store_registration_closed"] =
    "The deadline to register for the in-store benefit has passed.";

export default { en };
